import { IImageUploadServiceInjectable } from '@src/slide/application/service/image-upload-service/core/interface';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

export class ImageUploadServiceInjectable implements IImageUploadServiceInjectable {
    // your implementations here
    // 是否展示快捷美化
    public enableQuickTool(): boolean {
        return DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.quickTool) ?? true;
    }
}
